import React from 'react';
import { useField } from 'react-final-form';
import { styled } from '@linaria/react';

import { usePapersStore } from '@blocks/stores/settings';

import { ERROR_PAPER_INVALID } from '../../constants';
import { Label, Select } from '../../ui';
import { Spinner } from '../../ui/icon';
import { composeValidators } from '../../utils';
import { required } from '../../utils/validators';

const isRequired = required(ERROR_PAPER_INVALID);

const SelectChevron = styled.div`
  position: absolute;
  width: 45px;
  height: 45px;
  right: 0;
  top: 50%;
  margin-top: -22.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  z-index: -1;
`;

const Loading = styled.div`
  width: 100%;
  background-color: var(--bb-field-background);
  border-radius: var(--bb-field-border-radius);
  border-width: var(--bb-field-border-width);
  border-style: var(--bb-field-border-style);
  border-color: var(--bb-field-border-color);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--bb-field-placeholder);
  font-size: var(--bb-field-font-size);
  padding-top: var(--bb-field-padding-top);
  padding-right: var(--bb-field-padding-right);
  padding-bottom: var(--bb-field-padding-bottom);
  padding-left: var(--bb-field-padding-left);
  position: relative;

  & svg {
    fill: var(--bb-icon-color);
  }
`;

/**
 * @TODO refactor with new select component
 */
const Paper = ({ domain }) => {
  const papers = usePapersStore(domain);

  const { input, meta } = useField('paper_type', {
    validate: composeValidators(isRequired),
  });

  return (
    <>
      <Label>Type of paper</Label>

      {papers.length ? (
        <Select
          {...input}
          meta={meta}
          data-bb="paper_type"
        >
          {papers.map(({ id, title }) => (
            <option
              key={id}
              value={id}
            >
              {title}
            </option>
          ))}
        </Select>
      ) : (
        <Loading>
          Loading...
          <SelectChevron>
            <Spinner
              width="24"
              height="24"
            />
          </SelectChevron>
        </Loading>
      )}
    </>
  );
};

export default React.memo(Paper);
